import { render } from "./ResultDialog.vue?vue&type=template&id=32335c10&scoped=true"
import script from "./ResultDialog.vue?vue&type=script&lang=js"
export * from "./ResultDialog.vue?vue&type=script&lang=js"

import "./ResultDialog.vue?vue&type=style&index=0&id=32335c10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32335c10"]])

export default __exports__